import axios from 'axios';
import {
  GET_DETAILED_BALANCE_REQUEST,
  GET_DETAILED_BALANCE_SUCCESS,
  GET_DETAILED_BALANCE_FAILURE,

  POST_WITHDRAW_REQUEST,
  POST_WITHDRAW_SUCCESS,
  POST_WITHDRAW_FAILURE,

  GET_BALANCE_HISTORY_REQUEST,
  GET_BALANCE_HISTORY_SUCCESS,
  GET_BALANCE_HISTORY_FAILURE,

  GET_WITHDRAW_INFO_REQUEST,
  GET_WITHDRAW_INFO_SUCCESS,
  GET_WITHDRAW_INFO_FAILURE,
} from 'Store/constants';
import {
  updateUserBalance,
  openModal
} from 'Store/actions';
import { getChannel } from 'Utils/channel';
import errorMessage from './errorMessage';
import { MODAL_MESSAGES } from 'Store/constants/balanceHistory';
import EnvironmentManager from 'Utils/environmentManager';

export const getDetailedBalance = () => async dispatch => {
  try {

    dispatch({
      type: GET_DETAILED_BALANCE_REQUEST
    });

    // In order to set content type header, body must exists.
    const res = await axios.get('/account-balance', {
      data: {},
      headers: {
        'Content-Type': 'application/json'
      }
    });

    dispatch({
      type: GET_DETAILED_BALANCE_SUCCESS,
      payload: res.data
    });
  } catch (e) {
    dispatch({
      type: GET_DETAILED_BALANCE_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const postWithdrawMoneyV2 = (amount, iban, accountType, input, { bankName, formattedIban, amount: formattedAmount } = {}) => async dispatch => {
  try {
    dispatch({ type: POST_WITHDRAW_REQUEST });


    const requestBody = {
      amount: +amount,
      channel: getChannel(),
      accountType
    };

    if (accountType === 'IBAN') {
      requestBody.iban = iban;
    }

    const res = await axios.post('/withdraw/transaction/v2', requestBody);

    dispatch(openModal('withdrawSuccessModal', { message: res.data.description, bankName, formattedIban, amount: formattedAmount }));
    dispatch({ type: POST_WITHDRAW_SUCCESS });

    dispatch(getDetailedBalance());
    dispatch(updateUserBalance());
  } catch (e) {
    const errorCode = e.response && e.response.data && e.response.data.code;
    const withdrawMessages = EnvironmentManager.getMessageText({ key: 'one_second_withdraw_pop_up_text' });
    
    const cmsErrorMessage = errorCode ? EnvironmentManager.getMessageText({ key: `withdraw-api${errorCode}` }) : null;
    
    let message;
    if (errorCode === 3024) {
      message = withdrawMessages;
    } else {
      message = cmsErrorMessage || (e.response && e.response.data && e.response.data.message) || errorMessage.message;
    }

    if (errorCode === 3024) {
      dispatch(openModal('askPermissionModalV2', { message }));
      dispatch({ type: POST_WITHDRAW_SUCCESS });
    } else if (errorCode === 3030) {
      dispatch({ type: POST_WITHDRAW_FAILURE });
      dispatch(openModal('withdrawErrorModal', { message }));
      if (window.mixpanel) {
        window.mixpanel.track('View Uncontracted Bank Withdrawal Error Popup', {
          'Requested Withdrawal Amount': amount
        });
      }
    } else if (errorCode === 4008 || errorCode === 4009) {
      dispatch({ type: POST_WITHDRAW_FAILURE });
    } else {
      dispatch({ type: POST_WITHDRAW_FAILURE });
      dispatch(openModal('withdrawErrorModal', { message, code: errorCode }));
    }

  }
};

export const postWithdrawMoney = (amount, iban, accountType, input, { bankName, formattedIban, amount: formattedAmount } = {}) => async dispatch => {
  try {
    dispatch({ type: POST_WITHDRAW_REQUEST });


    const requestBody = {
      amount: +amount,
      channel: getChannel(),
      accountType
    };

    if (accountType === 'IBAN') {
      requestBody.iban = iban;
    }

    const res = await axios.post( '/withdraw', requestBody);

    dispatch(openModal('withdrawSuccessModal', { message: res.data.description, bankName, formattedIban, amount: formattedAmount }));
    dispatch({ type: POST_WITHDRAW_SUCCESS });

    dispatch(getDetailedBalance());
    dispatch(updateUserBalance());
  } catch (e) {
    const errorCode = e.response && e.response.data && e.response.data.code;
    const cmsErrorMessage = errorCode ? EnvironmentManager.getMessageText({ key: `withdraw-api${errorCode}` }) : null;
    const message = cmsErrorMessage || (e.response && e.response.data && e.response.data.message) || errorMessage.message;

    dispatch({ type: POST_WITHDRAW_FAILURE });
    dispatch(openModal('withdrawErrorModal', { message, code: errorCode }));

    if (errorCode === 3030) {
      if (window.mixpanel) {
        window.mixpanel.track('View Uncontracted Bank Withdrawal Error Popup', {
          'Requested Withdrawal Amount': amount
        });
      }
    }

  }
};

export const getBalanceHistory = ({
  startDate,
  endDate,
  pageNumber = 0,
  pageSize = 20,
  type = 'ALL',
}) => async dispatch => {
  try {

    dispatch({
      type: GET_BALANCE_HISTORY_REQUEST
    });

    // In order to set content type header, body must exists.
    const res = await axios.get('/account/payment-transfers/balance-history',
      {
        params: {
          startDate,
          endDate,
          pageNumber,
          pageSize,
          type,
        }
      }
    );

    dispatch({
      type: GET_BALANCE_HISTORY_SUCCESS,
      payload: res.data,
      pageNumber: pageNumber
    });
  } catch (e) {
    dispatch({
      type: GET_BALANCE_HISTORY_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getBalanceHistoryV2 = ({
  startDate,
  endDate,
  pageNumber = 0,
  pageSize = 20,
  type = 'ALL',
}) => async dispatch => {
  try {

    dispatch({
      type: GET_BALANCE_HISTORY_REQUEST
    });

    // In order to set content type header, body must exists.
    const res = await axios.get('/account/payment-transfers/balance-history/v2',
      {
        params: {
          startDate,
          endDate,
          pageNumber,
          pageSize,
          type,
        }
      }
    );

    dispatch({
      type: GET_BALANCE_HISTORY_SUCCESS,
      payload: res.data,
      pageNumber: pageNumber
    });
  } catch (e) {
    dispatch({
      type: GET_BALANCE_HISTORY_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getWithdrawInfo = (type, bankTransactionId) => async dispatch => {
  try {

    dispatch({
      type: GET_WITHDRAW_INFO_REQUEST
    });

    const res = await axios.post('/withdraw/info', {
      withdrawList: [
        {
          type: type,
          bankTransactionId: bankTransactionId
        }
      ]
    });

    dispatch({
      type: GET_WITHDRAW_INFO_SUCCESS,
      payload: res.data.withdraws[0],
    });

    if (res.data.withdraws[0]?.status)
      dispatch(openModal(MODAL_MESSAGES[type][res.data.withdraws[0]?.status].modalName));
  } catch (e) {
    dispatch({
      type: GET_WITHDRAW_INFO_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

